import {createActions} from 'reduxsauce';

export const {Types: SpaceTypes, Creators: SpaceActionCreators} = createActions ({
    spaceStart: null,
    spaceSuccess: ['space'],
    spaceFailure: ['error'],
    logoutStart: ['user'],

});